import { Routes } from '@angular/router';

export const legalRoutes: Routes = [
  {
    path: 'privacy',
    loadComponent: () =>
      import('./components/privacy/privacy.component').then((m) => m.PrivacyComponent),
  },
  {
    path: 'cookies',
    loadComponent: () =>
      import('./components/cookies/cookies.component').then((m) => m.CookiesComponent),
  },
];
